import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { faFolder, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { Select, Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { SetTabByIndex } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/tab-brick-behaviour/tab-brick-behaviour.actions';
import { TabBrickBehaviourState } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/tab-brick-behaviour/tab-brick-behaviour.state';
import { BrickGainedFocus } from 'src/app/store/dashboard/dashboard.actions';
import { TabContentRemoteDto } from '../../../../../generated/swagger';
import { BrickCategory } from '../../../../samwebDescription/samweb/brickCategoryType';
import { TabPositionType } from '../../../../samwebDescription/samweb/settings/tabBrick/tabPositionType';
import { BrickInstancesSelectors } from '../../../../store/dashboard/brick-wall/brick-instances/brick-instances.selectors';
import { InnerBrickWallSelectedInTabBrick } from '../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/inner-wall-brick-settings/inner-wall-brick-settings.actions';
import { TabBrickSettingsState } from '../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/tab-brick-settings/tab-brick-settings.state';
import { BasicBrickComponent } from '../../basic-brick-component';
import { SamwebBrick } from '../../samweb-brick.decorator';
import { TabBrickSettingsComponent } from './tab-brick-settings/tab-brick-settings.component';

@Component({
   selector: 'samweb-tab-brick',
   templateUrl: './tab-brick.component.html',
   styleUrls: ['./tab-brick.component.scss'],
})
@SamwebBrick({
   brickDefinitionId: 'tabBrick',
   brickTitleTranslationKey: 'brick.brick_definitions.tab-brick.title',
   brickDescriptionTranslationKey: 'brick.brick_definitions.tab-brick.description',
   brickIcon: faFolder,
   minColWidth: 10,
   minRowHeight: 10,
   brickCategory: BrickCategory.LAYOUT,
   settingsComponent: TabBrickSettingsComponent,
   settingStateHandler: TabBrickSettingsState,
   isLayoutBrick: true,
   allowBrickOverflow: true,
})
export class TabBrickComponent extends BasicBrickComponent implements OnInit, OnDestroy {
   private destroy$ = new Subject();

   public tabPosition$: Observable<TabPositionType>;
   public tabs$: Observable<Array<TabContentRemoteDto>>;

   public selectedTab$: Observable<number>;
   public allowBrickOverflow: boolean;
   public tabIcon: IconDefinition = faFolder;

   constructor(private store: Store) {
      super();
   }

   @Input()
   public brickInstanceId: string;

   @Select(BrickInstancesSelectors.isBrickWallEditable)
   public isBrickEditEnabled$: Observable<boolean>;

   ngOnInit() {
      this.selectedTab$ = this.store.select(TabBrickBehaviourState.getSelectedTabIndex).pipe(
         map((fn) => fn(this.brickInstanceId)),
         distinctUntilChanged()
      );
      this.tabPosition$ = this.store.select(TabBrickSettingsState.getTabPositionType).pipe(
         map((fn) => fn(this.brickInstanceId)),
         distinctUntilChanged()
      );
      this.tabs$ = this.store.select(TabBrickSettingsState.getTabs).pipe(
         map((fn) => fn(this.brickInstanceId)),
         distinctUntilChanged((prev, curr) => _.isEqual(prev, curr))
      );
   }

   ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
   }

   tabSelected(selectedIndex: number, tabs: TabContentRemoteDto[]) {
      // this is a workaround because we get no more information about the selected Tab from Kendo
      // !!! ATTENTION DO NOT USE THIS IN ANOTHER CODE-PARTS AS LONG THERE IS A BETTER (RXJS) WAY TO DO THAT
      if (!_.has(tabs, selectedIndex)) {
         return;
      }

      const selectedBrickInstanceId = tabs[selectedIndex].brickInstanceId;

      const brickDescription = this.store.selectSnapshot(BrickInstancesSelectors.brickDescriptionFn)(selectedBrickInstanceId);

      if (brickDescription.definition.brickDefinitionId === 'innerWall') {
         this.store.dispatch(new InnerBrickWallSelectedInTabBrick(selectedBrickInstanceId));
      }

      // selectedTab
      this.allowBrickOverflow = brickDescription.definition.allowBrickOverflow;
      this.store.dispatch(new SetTabByIndex(this.brickInstanceId, selectedIndex));

      if (brickDescription.definition.brickDefinitionId !== 'innerWall') {
         this.store.dispatch(new BrickGainedFocus(selectedBrickInstanceId));
      }
   }
}
